import LayoutUtils from 'src/utils/layout_utils';

/**
 * Count visible question wrappers that are still unanswered (display has --empty class).
 * Updates the screening section header badge.
 */
export function updateUnansweredCount(screeningSection) {
  if (!screeningSection) return;
  const body = screeningSection.querySelector('.js-showing-view-screening-body');
  const badge = screeningSection.querySelector('.js-showing-view-unanswered-badge');
  const countEl = screeningSection.querySelector('.js-showing-view-unanswered-count');
  if (!body || !badge || !countEl) return;

  let count = 0;
  body.querySelectorAll('.js-showing-view-question').forEach((wrap) => {
    if (wrap.offsetParent === null) return;
    const display = wrap.querySelector('.js-showing-view-question-display');
    if (display?.classList.contains('showing-view-popup__question-answer--empty')) count += 1;
  });

  countEl.textContent = count === 0 ? '0 unanswered' : `${count} unanswered`;
  LayoutUtils.toggle(badge, count > 0);
}
